import {type ChangeEventHandler, useCallback, useRef, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {selectDetails} from '~/CreateFabricInvitation/reducers/details/selectors';
import {useFormValidations} from '~/common/FabricInvitation/hooks/useFormValidations';
import {validateHost} from '~/common/FabricInvitation/utils/validation';
import {UPDATE_EVENT_DETAILS} from '~/common/fabric/reducers/details/constants';
import {InputWithRemove} from '../InputWithRemove/InputWithRemove';

export const Host = () => {
  const ref = useRef(null);
  const dispatch = useDispatch();
  const {host = ''} = useSelector(selectDetails);
  const [tempHost, setTemphost] = useState<string>(host);

  const [hasError, setHasError] = useState(false);

  // biome-ignore lint/correctness/useExhaustiveDependencies: existing error
  const updateHost = useCallback(
    (updatedHost: string) =>
      dispatch({
        type: UPDATE_EVENT_DETAILS,
        payload: {host: updatedHost},
      }),
    []
  );

  const onChangeHandler: ChangeEventHandler<HTMLInputElement> = useCallback(
    ({target: {value: newHost}}) => setTemphost(newHost),
    []
  );

  // biome-ignore lint/correctness/useExhaustiveDependencies: existing error
  const removeHost = useCallback(() => {
    setTemphost('');
    updateHost('');
  }, []);

  // biome-ignore lint/correctness/useExhaustiveDependencies: existing error
  const onExitEditModeHandler = useCallback(() => {
    setTemphost(tempHost);
    updateHost(tempHost);
  }, [tempHost]);

  const onExitEditModeValidation = useCallback((newHost?: string) => {
    const isValid = !!newHost?.trim()?.length;
    setHasError(!isValid);
    return isValid;
  }, []);

  // biome-ignore lint/correctness/useExhaustiveDependencies: existing error
  const validate = useCallback(() => {
    if (tempHost) {
      onExitEditModeHandler();
    }
    return validateHost(tempHost, ref.current);
  }, [hasError, tempHost]);

  useFormValidations('host', validate);

  return (
    <InputWithRemove
      ref={ref}
      name="host"
      dataQaId="event-host"
      type="text"
      value={tempHost}
      error={hasError && 'Event host is required'}
      onChange={onChangeHandler}
      onExitEditMode={onExitEditModeHandler}
      onExitEditModeValidation={onExitEditModeValidation}
      onRemove={removeHost}
      placeholder="Your Name"
      fullWidth
      showIcon={false}
    />
  );
};
